exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".body.home h1{color:#fff}.migration-page .section{gap:15px}.migration-page .description{font-style:italic}.migration-page .danger-text{font-weight:600;color:#881318;font-style:italic}.migration-page p{max-width:600px;line-height:1.2}.migration-page .field{padding-top:0;padding-bottom:0}.migration-page ul{padding-left:20px}.migration-page li{max-width:600px;line-height:1.2;margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Migrate/Migrate.scss
// module id = 887
// module chunks = 0